import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Nav from "@/ir/Nav";
import Hero from "@/ir/Hero";
import Marquee from "@/ir/Marquee";
import Manifesto from "@/ir/Manifesto";
import Products from "@/ir/Products";
import Traction from "@/ir/Traction";
import Funds from "@/ir/Funds";
import Pricing from "@/ir/Pricing";
import Milestones from "@/ir/Milestones";
import Founder from "@/ir/Founder";
import Materials from "@/ir/Materials";
import Contact from "@/ir/Contact";
import Footer from "@/ir/Footer";

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0E17] text-slate-100 antialiased">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Products />
        <Traction />
        <Funds />
        <Pricing />
        <Milestones />
        <Founder />
        <Materials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
